export type NavigationItem = {
  id: "crypto" | "macro";
  href: string;
  labelKey: string;
  icon: "crypto" | "macro";
};

export const DESKTOP_NAV: NavigationItem[] = [
  { id: "crypto", href: "/", labelKey: "nav.crypto", icon: "crypto" },
  { id: "macro", href: "/macro", labelKey: "nav.macro", icon: "macro" }
];

export const MOBILE_NAV = DESKTOP_NAV;
